module.exports = __webpack_public_path__ + "img/Android_man_avatar_talk_.01d959b4.png";